import axios from "axios"
import { CreateEmployeeInterface, GetAllEmployeesInterface, GetEmployeeInterface } from "@type/employees.types"

const ROOT_PATH = "employees/details"
const ROOT_PATH_PARENT = "employees"

export default class EmployeesService {
	static createEmployee = (employee: CreateEmployeeInterface) => axios.post<GetEmployeeInterface>(ROOT_PATH, employee)

	static getAllEmployees = () => axios.get<GetAllEmployeesInterface[]>(ROOT_PATH)

	static getEmployeeByActiveStatus = (isActive = true) =>
		axios.get<Array<GetEmployeeInterface>>(`${ROOT_PATH}-active`, {
			params: {
				isActive,
			},
		})
	static getEmployeeById = (id: string) => axios.get<GetEmployeeInterface>(`${ROOT_PATH}/${id}`)

	static getEmployeeBySearch = (employee: { shortName?: string; clientPin?: string; reference?: string }) =>
		axios.get<GetEmployeeInterface>(`${ROOT_PATH_PARENT}/enhanced-search`, { params: employee })

	static updateEmployee = (id: string, employee: CreateEmployeeInterface) =>
		axios.put<GetEmployeeInterface>(`${ROOT_PATH}/${id}`, employee)
}
